import type { Color } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

/** sx for a tinted chip in one MUI hue: a soft wash of the hue behind text in it, in either colour scheme. */
export const toChipColourSx = (hue: Color) => (theme: Theme): SystemStyleObject<Theme> => ({
  bgcolor: alpha(hue[500], 0.1),
  color: hue[800],
  ...theme.applyStyles("dark", {
    bgcolor: alpha(hue[400], 0.16),
    color: hue[300],
  }),
});

/** sx for a count on a tinted chip: a solid pill in the chip's text colour. */
export const toChipBadgeColourSx = (hue: Color) => (theme: Theme): SystemStyleObject<Theme> => ({
  bgcolor: hue[800],
  color: "background.default",
  ...theme.applyStyles("dark", {
    bgcolor: hue[300],
  }),
});
